import { render, staticRenderFns } from "./FormulaPanel.vue?vue&type=template&id=4b43040a&scoped=true"
import script from "./FormulaPanel.vue?vue&type=script&lang=js"
export * from "./FormulaPanel.vue?vue&type=script&lang=js"
import style0 from "./FormulaPanel.vue?vue&type=style&index=0&id=4b43040a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b43040a",
  null
  
)

export default component.exports